<div class="login-box">
  <a (click)="close()" class="login-box-close">
    <i class="pi pi-times-circle"></i>
  </a>
  @if (invitation_join) {
    <div class="bg-muted-t alert-in-page mb-3">
      <div class="flex align-items-center gap-3">
        <p-avatar
          [image]="
            invitation_join.from_user.profile_picture
              | imagePipe: 'user-w' : 'sm'
          "
          shape="circle"
          size="large"
        ></p-avatar>
        <div class="flex flex-column gap-1">
          <strong
            >{{ invitation_join.from_user.name }} ti ha invitato a un
            viaggio!</strong
          >
          <small>Effettua l'accesso o registrati per partecipare.</small>
        </div>
      </div>
    </div>
  }
  @if (invitation_assignment) {
    <div class="bg-muted-t alert-in-page mb-3">
      <div class="flex align-items-center gap-3">
        <p-avatar
          [image]="
            invitation_assignment.from_user.profile_picture
              | imagePipe: 'user-w' : 'sm'
          "
          shape="circle"
          size="large"
        ></p-avatar>
        <div class="flex flex-column gap-1">
          <strong
            >{{ invitation_assignment.from_user.name }} vuole assegnarti un
            viaggio!</strong
          >
          <small>Effettua l'accesso per visualizzare la notifica.</small>
        </div>
      </div>
    </div>
  }
  @if (!showRegister) {
    <div class="account">
      <h2>Accedi</h2>
      @if (login_error) {
        <div class="muted-r-bg alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Si è verificato un errore</strong>
              <small>{{ err_message }}</small>
            </div>
          </div>
        </div>
      }
      @if (!passwordForgotten) {
        <form [formGroup]="frmLogin" (ngSubmit)="login()">
          <div>
            <label>E-mail</label>
            <input
              type="text"
              pInputText
              formControlName="email"
              class="w-full"
            />
            @if (
              frmLogin.get("email")?.errors && frmLogin.get("email")?.touched
            ) {
              <st-errors [errors]="frmLogin.get('email')?.errors"></st-errors>
            }
          </div>
          <div class="mt-3 flex flex-column gap-1">
            <label>Password</label>
            <p-password
              formControlName="password"
              class="w-full"
              [toggleMask]="true"
              [feedback]="false"
            ></p-password>
            <!-- <input type="password" pInputText formControlName="password" class="w-full"> -->
            @if (
              frmLogin.get("password")?.errors &&
              frmLogin.get("password")?.touched
            ) {
              <st-errors
                [errors]="frmLogin.get('password')?.errors"
              ></st-errors>
            }
          </div>
          <div class="new-pass flex justify-content-end mt-2">
            <a (click)="passwordForgotten = true" class="link-o"
              >Reimposta password</a
            >
          </div>
          <div class="mt-3 flex align-items-center justify-content-center">
            <p-button
              label="Accedi"
              size="small"
              styleClass="slide-o px-6"
              [disabled]="frmLogin.invalid"
              type="submit"
            ></p-button>
          </div>
        </form>
      } @else {
        <form [formGroup]="frmForgottenPass" (ngSubmit)="getPassword()">
          <small class="grey-text"
            >Inserisci la tua mail per ricevere le istruzioni per reimpostare la
            tua password.</small
          >
          <div class="mt-2">
            <label>E-mail</label>
            <input
              type="text"
              pInputText
              formControlName="email"
              class="w-full"
            />
            @if (
              frmForgottenPass.get("email")?.errors &&
              frmForgottenPass.get("email")?.touched
            ) {
              <st-errors
                [errors]="frmForgottenPass.get('email')?.errors"
              ></st-errors>
            }
          </div>
          <div class="mt-5 flex align-items-center justify-content-center">
            <p-button
              label="Invia"
              size="small"
              styleClass="slide-o px-6"
              [disabled]="frmForgottenPass.invalid"
              type="submit"
            ></p-button>
          </div>
          @if (passwordForgotten_msg) {
            <div class="bg-muted-o alert-in-page my-3">
              <div class="flex align-items-center gap-3">
                <img src="/assets/media/icons/alert-g.png" width="40" />
                <div class="flex flex-column gap-1">
                  <strong>Controlla la tua posta elettronica</strong>
                  <small
                    >Ti abbiamo mandato una mail contenente un link per il
                    recupero della tua password.</small
                  >
                  <small class="grey-text mt-2 font-bold"
                    >Se non vedi la mail nella tua posta, controlla lo
                    spam!</small
                  >
                </div>
              </div>
            </div>
          }
        </form>
      }

      <div
        class="mt-5 alternative-login flex flex-column justify-content-center gap-3"
      >
        <small class="grey-text text-center">oppure</small>
        <a
          [href]="googleUrl"
          class="block login flex align-items-center justify-content-center gap-3"
        >
          <img src="/assets/media/icons/google-login.png" />
          <span>Accedi con Google</span>
        </a>
        @if (gotoWithoutLogin) {
          <div class="text-center mt-2">
            <strong>
              <a class="link-inline" (click)="proceedWithoutRegister()"
                >Non registrarmi</a
              >
            </strong>
          </div>
        }
      </div>
      <div
        class="flex gap-1 align-items-center justify-content-center register-cta"
      >
        <span>Non hai un account?</span>
        <strong
          ><a
            class="green"
            (click)="gotoRegister()"
            routerLink="/register"
            [queryParams]="back_to_url ? { back_to_url } : {}"
            >Registrati!</a
          ></strong
        >
      </div>
    </div>
  }
  @if (showRegister) {
    <div class="new-account">
      <h2>Crea un account</h2>

      @if (invitation_reg) {
        <div class="bg-muted-t alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <p-avatar
              [image]="
                invitation_reg.from_user.profile_picture
                  | imagePipe: 'user-w' : 'sm'
              "
              shape="circle"
              size="large"
            ></p-avatar>
            <div class="flex flex-column gap-1">
              <strong
                >{{ invitation_reg.from_user.name }} ti ha invitato a
                registrarti!</strong
              >
              <small
                >Compila i campi qui sotto e segui le istruzioni per iniziare la
                tua avventura su SocialTravels</small
              >
            </div>
          </div>
        </div>
      }
      @if (activation_code) {
        <div class="bg-muted-o alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Controlla la tua posta elettronica</strong>
              <small
                >Ti abbiamo mandato una mail contenente un link per
                l'attivazione del tuo account.</small
              >
              <small class="mt-2 font-bold"
                >Se non vedi la mail nella tua posta, controlla lo spam!</small
              >
            </div>
          </div>
        </div>
      }
      @if (activation_code_error) {
        <div class="muted-r-bg alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Si è verificato un errore</strong>
              <small>{{ err_message }}</small>
            </div>
          </div>
        </div>
      }
      @if (!activation_code) {
        <form [formGroup]="frmRegister" (ngSubmit)="register()">
          <div>
            <label>E-mail</label>
            <input
              type="text"
              pInputText
              formControlName="email"
              class="w-full"
            />
            @if (
              frmRegister.get("email")?.errors &&
              frmRegister.get("email")?.touched
            ) {
              <st-errors
                [errors]="frmRegister.get('email')?.errors"
              ></st-errors>
            }
          </div>
          <div class="mt-3 flex flex-column gap-1">
            <label>Password</label>
            <p-password
              formControlName="password"
              class="w-full"
              [toggleMask]="true"
              [feedback]="false"
            ></p-password>
            <!-- <input type="password" pInputText formControlName="password" class="w-full"> -->
            @if (
              frmRegister.get("password")?.errors &&
              frmRegister.get("password")?.touched
            ) {
              <st-errors
                [errors]="frmRegister.get('password')?.errors"
              ></st-errors>
            }
          </div>
          <div class="flex align-items-center gap-2 mt-4">
            <p-checkbox formControlName="checked_conditions" [binary]="true" />
            <div class="flex align-items-center gap-1">
              <span class="font-12">Accetto</span>
              <a
                class="link-o font-12 font-bold"
                href="https://www.iubenda.com/termini-e-condizioni/91100971"
                target="_blank"
                >i termini e condizioni</a
              >
              <span class="font-12">e</span>
              <a
                class="link-o font-12 font-bold"
                href="https://www.iubenda.com/privacy-policy/91100971"
                target="_blank"
                >l'informativa sulla privacy</a
              >
            </div>
          </div>
          <div class="mt-5 flex align-items-center justify-content-center">
            <p-button
              type="submit"
              label="Crea account"
              size="small"
              styleClass="slide-o px-6"
              [disabled]="frmRegister.invalid"
            ></p-button>
          </div>
        </form>
      }
      @if (!activation_code) {
        <div class="flex gap-1 align-items-center justify-content-center mt-4">
          <span>Hai già un account?</span>
          <a class="green link-o" routerLink="/login">Accedi</a>
        </div>
      }
    </div>
  }
</div>
